import * as angular from "angular";
import template from "./entity-inventory-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";
import { globs } from "../../../../services/globs";
import { isSupportedOrNullish } from "../../isSupportedOrNullish";
import type {
	EntityModel,
	EntityOperation,
	EntityTypeConfig
} from "./entityModalTabTypes";

export interface EntityInventoryTabController {
	entity?: EntityModel;
	typeConfig: EntityTypeConfig;
	put: EntityOperation;
	post: EntityOperation;
}

// eslint-disable-next-line no-redeclare
export class EntityInventoryTabController {
	public static $inject = ["securityService"];

	public tab!: ModalTabItem;

	public constructor(private readonly securityService) {}

	public $onInit(): void {
		const canViewInventory = globs.entityTypes.byType(this.typeConfig.Code).inventory.byCode("*").read;
		this.tab = {
			name: "Inventory",
			code: "INVENTORY",
			isAvailable: !!(
				this.securityService.isActionOrPatternAllowed(canViewInventory)
				&& isSupportedOrNullish(this.typeConfig.Inventory)
			)
		};
	}
}

export default angular
	.module("vesl.components.entity-modal.tabs.entity-inventory-tab", [])
	.component("entityInventoryTab", {
		controller: EntityInventoryTabController,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<",
			put: "=",
			post: "="
		}
	})
	.name;
